import './styles.css';

export enum EventType {
	Mark = 'mark',
	Draw = 'draw',
	Win = 'win'
}

type EventItemType = {
	log: string
	type: EventType
}; 

type EventProps = {
	events: EventItemType[]
}


const Event = ( {events}: EventProps): JSX.Element => {
	return (
		<div role='log'>
			<ul className="event">
				{events.map((item, index) => 
				<li key={index} className={item.type}>{item.log}</li>
				)}
			</ul>
		</div>
	);
}

export default Event;